import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'

export const Banner = styled.div`
  top: 0;
  position: fixed;
  height: ${calculateResponsiveSize(39)};
  width: 100%;
  font-family: 'HW Atlantic';
  font-size: ${calculateResponsiveSize(18)};
  font-style: normal;
  font-weight: 400;
  line-height: ${calculateResponsiveSize(24)}; /* 133.333% */
  letter-spacing: -1px;
  z-index: 106;
  background: var(--blue);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(0);
  transition: 1s;
  /* animation: slideFromTop 1s ease-in-out 3s forwards; */
  &.homeStart {
    transform: translateY(-100%);
  }
  &:not(.home) {
    transform: translateY(0) !important;
  }

  @keyframes slideFromTop {
    0% {
      transform: translateY(-100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  ${mediaMax('mobile')} {
    height: 39px;
    font-size: 18px;
    line-height: 24px;
  }
`
